<template lang="pug">
  .b2b-page-issue
    ods-module
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(:span='8')
            div {{ $t('msg_generics.information') }}
          ods-col(:span='16')
             ods-row(type='flex', justify='end')
                ods-tooltip(:content='$t("buttons.btnDelete")', placement='bottom')
                  div
                    ods-button(
                      v-if="canDeleteIssue || canAdminIndra"
                      type='primary',
                      icon='ods-icon-delete',
                      size='small',
                      circle,
                      @click.native='handleErase')
                      | {{ $t('buttons.btnDelete') }}
      ods-form(
        ref='issueDetailEditForm',
        :model='issueDetailEditForm',
        label-width='14rem',
        label-position='top',
        size='small',
        status-icon)
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              v-if='!activeUser.data.projects || (activeUser.data.projects && activeUser.data.projects.length > 1)',
              :label='$t("documentation_detail.documentation_detail_form.project")',
              prop='project')
              ods-input(
                v-model='issueDetailEditForm.projectName'
                :disabled='true')
            ods-form-item(
              :label='$t("invoice_detail.invoice_detail_edit_form.buyer")',
              prop='buyerName')
              ods-input(
                v-model='issueDetailEditForm.buyerName',
                :disabled='true')
            ods-form-item(
              :label='$t("issues.filters.subject.value")',
              prop='summary')
              ods-input(
                v-model='issueDetailEditForm.summary'
                :disabled='true')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("issues.filters.priority.value")',
              prop='priority')
              ods-input(
                v-model='formatterIssuePriority',
                :disabled='true')
            ods-form-item(
              :label='$t("invoice_detail.invoice_detail_edit_form.seller")',
              prop='sellerName')
              ods-input(
                v-model='issueDetailEditForm.sellerName',
                :disabled='true')
        ods-row(type='flex')
          ods-col(:span='10')
        ods-row
          ods-form-item.small(
          :label='$t("new_invoice.new_invoice_form.additional_data")',
          prop='description')
          ods-input(
            type='textarea',
            :disabled='true',
            v-model='issueDetailEditForm.description')
    ods-module.collapse
      ods-accordion(@change='')
        ods-accordion-item( name='1')
          template(slot='title')
            span {{ $t('issues.historic.title') }}
            span.info(v-show='!issueshistoric.length') {{ $t('issues.historic.no_data') }}
          //- Tabla de historico
          ods-tooltip(:content='$t("issues.historic.addStatus_tooltip")', placement='bottom')
          ods-button.button-collapse(
            v-if="canUpdateIssue || canAdminIndra"
            icon='ods-icon-plus',
            size='small',
            circle,
            @click.native='handleShowAddIssue')
            | {{ $t('issues.historic.addStatus') }}
          ods-table(
            v-if='issueshistoric.length > 0 ',
            :data='issueshistoric',
            :default-sort="{ prop: 'id', order: 'descending' }",
            style='width: 100%',
            @cell-mouse-enter='handleCellMouseEnter',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='creationDate',
              :label='$t("issues.historic.creationDateTime")',
              :show-overflow-tooltip='true',
              :formatter='formatterDate',
              sortable='')
            ods-table-column(
              prop='issueStatus',
              :label='$t("issues.historic.status")',
              :show-overflow-tooltip='true',
              :formatter='formatterStatus'
              sortable='')
            ods-table-column(
              prop='comment',
              :label='$t("issues.historic.comment")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='user',
              :label='$t("issues.historic.user")',
              :show-overflow-tooltip='true',
              sortable='')
    //- Dialog crear evento
    ods-dialog(
      ref='dialogAddIssueStatus',
      :title='$t("issues.historic.addStatus_tooltip")',
      :visible.sync='isShowDialogAddIssueStatus',
      @close='handleCloseDialogAddIssueStatus',
      width='30%')
      ods-form(
        ref='formDialogAddIssueStatus',
        :rules='rulesDialogAddIssueStatus',
        :model='formDialogAddIssueStatus')
        ods-form-item(
          :label='$t("issues.dialog_add_status.status")',
          prop='status')
          ods-select(
            :no-match-text='$t("msg_generics.no_match")',
            v-model='formDialogAddIssueStatus.status',
            :placeholder='$t("issues.dialog_add_status.status")',
            filterable)
            ods-option(
              v-for='option in this.optionsStatusList',
              :key='option.id',
              :label="$t('issue.status.' + option.status)",
              :value='option.id')
        ods-form-item(
          :label='$t("issues.dialog_add_status.comment")',
          prop='comment')
          ods-input(
            v-model='formDialogAddIssueStatus.comment')
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='onSubmitAddIssueStatus("formDialogAddIssueStatus")')
          | {{ $t('issues.dialog_add_status.load_status') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import B2bTimeline from '@/components/B2bTimeline'
import Utils from '@/components/shared/Utils'
import moment from 'moment'

export default {
  name: 'b2b-page-issue',

  mixins: [Utils],

  data () {
    return {
      // INFO
      issueOriginal: {}, // incidencia original sin modificaciones de ningun tipo
      project: {}, // proyecto de la incidencia
      issueId: null,
      issueDetailEditForm: {
        status: null,
        buyerName: null,
        sellerName: null,
        creationDateTime: null,
        projectName: null,
        priority: null,
        summary: null,
        description: null
      },
      isShowDialogAddIssueStatus: false,
      formDialogAddIssueStatus: {
        status: null,
        comment: null
      },

      // ADJUNTOS
      attachments: [],
      currentRowEvent: {},
      fileList: [],
      // EVENTOS
      issueshistoric: [],
      optionsStatusList: []

    }
  },

  components: {
    B2bTimeline
  },

  computed: {
    ...mapGetters([
      'optionsFilterPriorityIssue',
      'optionsFilterTypeIssue',
      'canAdminIndra',
      'canUpdateIssue',
      'canDeleteIssue',
      'activeUser'
    ]),

    rulesDialogAddIssueStatus () {
      return {
        status: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' }
        ],
        comment: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' }
        ]
      }
    },
    // Formatear estado de la incidencia
    formatterIssuePriority () {
      if (this.issueDetailEditForm.priority) {
        return this.$t('issue.priority.value_' + this.issueDetailEditForm.priority)
      }
      return this.issueDetailEditForm.priority
    }
  },

  methods: {
    ...mapActions([
      'getIssueById',
      'getIssueStatus',
      'getStatusIssue',
      'deleteIssue',
      'addIssueStatus'

    ]),

    formatterDate (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format_long'))
      }
      return this.$t('msg_generics.no_date')
    },
    // Formatear estado de la incidencia
    formatterStatus (row, column) {
      return this.$t('issue.status.' + row[column.property])
    },
    async handleErase () {
      this.$confirm(this.$t('issues.confirm.title_delete'), {
        confirmButtonText: this.$t('issues.confirm.confirm_button_delete'),
        showCancelButton: false,
        center: true,
        iconClass: 'ods-icon-warning'
      }).then(async () => {
        const load = this.$loading({
          lock: true,
          text: this.$t('isues.load.delete')
        })
        try {
          await this.deleteIssue(this.issueId)
          this.$notify({
            title: this.$t('issues.notify.delete_ok'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
          router.push({ name: 'issues-table' })
        } catch (error) {
          console.log('handleErase CATCH: ', error)
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      }).catch(() => {})
    },
    async handleShowAddIssue () {
      this.isShowDialogAddIssueStatus = true
      const params = { withoutLast: true, idIssue: this.issueId }
      this.optionsStatusList = await this.getStatusIssue(params)
    },
    onSubmitAddIssueStatus (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('issues.load.add_status')
          })
          console.log('onSubmitAddIssueStatus: ', this.formDialogAddIssueStatus)
          try {
            const params = {
              idIssue: this.issueId,
              idStatus: this.formDialogAddIssueStatus.status,
              description: this.formDialogAddIssueStatus.comment
            }
            console.log('params ', params)
            await this.addIssueStatus(params)

            this.$refs[formName].clearValidate()

            this.$notify({
              title: this.$t('issues.notify.add_status_ok'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
            // Refrescamos
            this.issueshistoric = await this.getIssueStatus(this.issueId)
          } catch (error) {
            console.log('onSubmitAddIssueStatus CATCH: ', error)
            this.getNotificationErrorMessage(error)
            this.$refs[formName].resetFields()
          } finally {
            this.isShowDialogAddIssueStatus = false
            load.close()
          }
        } else {
          console.log('onSubmitAddIssueStatus: ', this.formDialogAddIssueStatus)
          return false
        }
      })
    },

    async getIssueOnDatabase () {
      try {
        const incidencia = await this.getIssueById(this.issueId)
        this.issueOriginal = JSON.parse(JSON.stringify(incidencia))
        this.issueDetailEditForm = incidencia
      } catch (error) {
        console.log('getIssueOnDatabase CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },

    handleCellMouseEnter (row, column, cell, event) {
      this.currentRowEvent = row
    },

    renderHeaderActions: function (createElement) {
      return createElement('i', {
        class: 'ods-icon-setting'
      })
    },

    // Reseteo formulario al cerrar dialogo de añadir estado
    handleCloseDialogAddIssueStatus () {
      this.$refs.formDialogAddIssueStatus.resetFields()
    },
    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 401:
          errorSms = this.$i18n.messages.es.error.e401
          break
        case 403:
          errorSms = this.$i18n.messages.es.error.e403
          break
        case 400:
        case 404:
        case 500:
          errorSms = error.data.message
          if (errorSms === undefined && error.config.responseType === 'blob') {
            errorSms = this.$t('msg_generics.error_download_not_found')
          }
          break
        case 409:
          errorSms = error.data.message
          break
        default:
          errorSms = this.$i18n.messages.es.error.default
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })
    try {
      this.issueId = this.$route.params.issueId

      // Get Info
      await this.getIssueOnDatabase()
      // get historic
      this.issueshistoric = await this.getIssueStatus(this.issueId)
    } catch (error) {
      console.log('created CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
    load.close()
  }
}
</script>

<style lang="scss" scoped>
.b2b-page-issue{
  padding: 40px 40px 40px 40px;

  .ods-table {
    &__row {
      .ods-button {
        padding: 0px;
        margin-left: 0px;
        margin-right: 0px;
        i {
          margin-left: 0px;
        }
      }
      .first-button {
        padding: 0px;
        margin-left: 0px;
        margin-right: rem(12);
        i {
          margin-left: 0px;
        }
      }
    }
  }

  ::v-deep .ods-module {
    &__header {
      background-color: var(--color-bg-hover-2);
      padding: 0px;

      .info {
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
      .ods-button {
        float: right;
      }
    }

    &__body{
      padding: 32px;
      .info{
        padding-bottom: 32px;
      }
    }
  }

  .form-actions {
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button {
      float: right;
    }
  }

  .collapse {
    margin-top: 64px;
    .info {
      margin-left: 1rem;
      color: var(--color-status-info-400);
    }

    ::v-deep .ods-table {
      th {
        padding: rem(0);
        padding-top: rem(4);

        .cell {
          font-weight: 500;
        }
      }
      &__row{
        .ods-button {
          padding: 0px;
          margin-left: 0px;
          margin-right: 0px;
          i {
            margin-left: 0px;
          }
        }
        .first-button {
          padding: 0px;
          margin-left: 0px;
          margin-right: rem(12);
          i {
            margin-left: 0px;
          }
        }
      }
    }

    .button-collapse {
      float: right;
    }

    ::v-deep .ods-module{
      &__body{
        padding: 0px;
      }
    }
  }
  ::v-deep .ods-checkbox {
    padding-top: 20px;
  }
  ::v-deep .ods-form-item.small {
    margin-bottom: 0px !important;

  }
}
</style>
